var _rect, _rect2, _rect3, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _tspan12, _tspan13, _path, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _path2, _path3, _path4, _path5, _path6, _path7, _line, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _line2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect4, _rect5, _tspan20, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _line3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect6, _rect7, _tspan21, _path24, _path25, _line4, _path26, _line5, _line6, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _line7, _path45, _path46, _path47, _path48, _path49, _circle19, _circle20, _path50, _path51, _circle21, _path52, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _path53, _circle22, _path54, _circle23, _path55, _circle24, _circle25, _circle26, _path56, _path57, _circle27, _path58, _path59, _circle28, _path60, _circle29, _path61, _circle30, _path62, _circle31, _path63, _circle32, _path64, _circle33, _path65, _circle34, _path66, _circle35, _path67, _circle36, _path68, _circle37, _path69, _circle38, _path70, _circle39, _path71, _path72, _circle40, _path73, _path74, _circle41, _path75, _circle42, _path76, _path77, _path78, _path79, _path80, _path81, _g, _g2, _g3, _path82, _path83, _path84, _ellipse, _ellipse2, _ellipse3, _circle43, _circle44, _circle45, _circle46, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _rect8, _rect9, _tspan34, _tspan35, _path96, _path97, _rect0, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _rect1, _rect10, _line8, _tspan47, _line9, _tspan48, _line0, _g4, _tspan49, _ellipse4, _ellipse5, _line1, _line10, _tspan50, _ellipse6, _ellipse7, _line11, _line12, _rect11, _tspan51, _tspan52, _tspan53, _rect12, _tspan54, _tspan55, _tspan56, _rect13, _tspan57, _rect14, _tspan58, _tspan59, _tspan60, _rect15, _tspan61, _tspan62, _tspan63, _tspan64, _tspan65, _tspan66, _tspan67, _tspan68, _tspan69, _tspan70, _tspan71, _tspan72, _tspan73, _tspan74, _tspan75, _tspan76, _tspan77, _tspan78, _tspan79, _tspan80, _tspan81, _rect16, _tspan82, _tspan83, _tspan84, _tspan85, _tspan86, _tspan87, _tspan88, _tspan89, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmCircuitDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1905,
    height: 1135,
    viewBox: "0 0 1905 1135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1905,
    height: 1135,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Series Point Machine Diagram",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1905,
    height: 1135,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 0.5,
    y: 0.5,
    width: 1904,
    height: 1134,
    rx: 14.5,
    fill: "#FFFBF7",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Outdoor Detection",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1611,
    y: 542.455
  }, "Outdoor Detection"))), /*#__PURE__*/React.createElement("text", {
    id: "ND",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1111,
    y: 778.455
  }, "ND"))), /*#__PURE__*/React.createElement("text", {
    id: "RD",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 1164,
    y: 1043.45
  }, "RD"))), /*#__PURE__*/React.createElement("text", {
    id: "Point Operation Circuit",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 25,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 686,
    y: 71.0909
  }, "Point Operation Circuit"))), /*#__PURE__*/React.createElement("text", {
    id: "Point Detection Circuit",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 25,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 686,
    y: 761.091
  }, "Point Detection Circuit"))), /*#__PURE__*/React.createElement("text", {
    id: "B24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1511,
    y: 794.864
  }, "B24"))), /*#__PURE__*/React.createElement("text", {
    id: "N24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1511,
    y: 892.864
  }, "N24"))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 431,
    y: 783.864
  }, "RWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 572,
    y: 783.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 572,
    y: 879.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 572,
    y: 950.864
  }, "(R)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 572,
    y: 1045.86
  }, "(R)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 431,
    y: 879.864
  }, "RWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 431,
    y: 950.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 431,
    y: 1045.86
  }, "NWKR"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_RWKR_Wire1",
    d: "M1301.5 792L1330 803V950V963L962 959.5",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B110(PT)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 131,
    y: 364.864
  }, "B110(PT)"))), /*#__PURE__*/React.createElement("text", {
    id: "N110(PT)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 130,
    y: 448.864
  }, "N110(PT)"))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    y: 810.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    y: 976.864
  }, "RWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "RWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 222,
    y: 843.864
  }, "RWR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 222,
    y: 1011.86
  }, "NWR"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "NWKR_DETECTION2",
    d: "M183.5 791.5L161 803V859.5H304.5V803L286 791.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "NWKR_DETECTION1",
    d: "M182.5 792V819.5H287V792",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "RWKR_DETECTION2",
    d: "M180 960.5L161 972V1028.5H304.5V972L284.5 960.5",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "RWKR_DETECTION1",
    d: "M179.5 960V987.5H284V960",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M739.5 152.5L713.5 170.5V214.5H805.5V170.5L779.5 152.5",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M937.5 360.5L985.5 148",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 189,
    y1: 360,
    x2: 937,
    y2: 360,
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M189 443H980",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M558.5 360L531 348.5V152H739H930L987 356.5",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POINT1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 1079.5,
    cy: 242.5,
    r: 12.5,
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 1059.5,
    cy: 243.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 1099.5,
    cy: 243.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 1146.5,
    cy: 176.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 1147.5,
    cy: 309.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 1147.5,
    cy: 205.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 1147.5,
    cy: 279.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 1105,
    y1: 243,
    x2: 1114,
    y2: 243,
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Line 7",
    d: "M1113.5 206H1142",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M1113.5 280H1142",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M1114.5 252.5V233.5",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line 8",
    d: "M1146.5 200.5V181.5",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Line 11",
    d: "M1147.5 304.5V285.5",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M1114.5 216.5V205.5",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Line 9",
    d: "M1114.5 280.5V269.5",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    d: "M1041 243H1054",
    stroke: "black",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 1110,
    y: 217,
    width: 10,
    height: 17,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 1110,
    y: 253,
    width: 10,
    height: 17,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "M",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1073,
    y: 248.455
  }, "M")))), /*#__PURE__*/React.createElement("g", {
    id: "POINT2"
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 1354.5,
    cy: 241.5,
    r: 12.5,
    stroke: "black",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 1334.5,
    cy: 242.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 1374.5,
    cy: 242.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 1421.5,
    cy: 175.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 1422.5,
    cy: 308.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 1422.5,
    cy: 204.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 1422.5,
    cy: 278.5,
    r: 5.5,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 1380,
    y1: 242,
    x2: 1389,
    y2: 242,
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Line 13",
    d: "M1388.5 205H1417",
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Line 14",
    d: "M1388.5 279H1417",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Line 15",
    d: "M1389.5 251.5V232.5",
    stroke: "black",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Line 16",
    d: "M1421.5 199.5V180.5",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Line 17",
    d: "M1422.5 303.5V284.5",
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Line 18",
    d: "M1389.5 215.5V204.5",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Line 19",
    d: "M1389.5 279.5V268.5",
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Line 20",
    d: "M1316 242H1329",
    stroke: "black",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 1385,
    y: 216,
    width: 10,
    height: 17,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 1385,
    y: 252,
    width: 10,
    height: 17,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "M_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1348,
    y: 248.455
  }, "M")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M1292 148H1491",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M985.5 148H1179",
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 21",
    x1: 1115,
    y1: 176.5,
    x2: 1141,
    y2: 176.5,
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Line 40",
    d: "M1029 442.5H1042",
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line 26",
    x1: 1115,
    y1: 94.5,
    x2: 1141,
    y2: 94.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line 39",
    x1: 993,
    y1: 442.5,
    x2: 1016,
    y2: 442.5,
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Line 22",
    d: "M1152 176.5H1178",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M1266 94.5H1292",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M1426 175.5H1491",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Line 35",
    d: "M1427 309.5H1502",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Line 29",
    d: "M1154 94.5H1180",
    stroke: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Line 32",
    d: "M1502 350.5V309.5",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Line 36",
    d: "M1491 175.5V147.5",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Line 28",
    d: "M1191 94.5H1253",
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Line 23",
    d: "M1115.5 141C1106 143.5 1107.5 154 1115.5 155",
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Line 24",
    d: "M1115.5 154.5V177",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    d: "M986.5 448.5V484",
    stroke: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Line 37",
    d: "M1178.5 147.5V177",
    stroke: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Line 25",
    d: "M1291.5 94.5V148.5",
    stroke: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Line 30",
    d: "M1115.5 94.5V141.5",
    stroke: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Line 38",
    d: "M1041.5 242.5V442.5",
    stroke: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Line 47",
    d: "M1316.5 241.5V483.5",
    stroke: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_RWKR_Wire3",
    d: "M1388 889.5V1052.24",
    stroke: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_RWKR_Wire2",
    d: "M1180 1052H1388",
    stroke: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 1147.5,
    cy: 94.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 986.5,
    cy: 442.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 1022.5,
    cy: 442.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 1184.5,
    cy: 94.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 1259.5,
    cy: 94.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 1501.5,
    cy: 356.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line 33",
    x1: 1152,
    y1: 309.5,
    x2: 1417,
    y2: 309.5,
    stroke: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Line 48",
    d: "M987 483.5H1317",
    stroke: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_NWKR_Wire1",
    d: "M1129 791.5H1254",
    stroke: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_NWKR_Wire2",
    d: "M1302 791.5H1499",
    stroke: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Outdoor_Detection_NWKR_Wire3",
    d: "M1311 889.5H1502",
    stroke: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Line 34",
    d: "M987 356.5H1495",
    stroke: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 565.5,
    cy: 151.5,
    r: 5.5,
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 740.5,
    cy: 151.5,
    r: 5.5,
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M597.5 141L602.5 149.5L609.5 141",
    stroke: "black",
    strokeWidth: 3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M774.5 141L779.5 149.5L786.5 141",
    stroke: "black",
    strokeWidth: 3
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 740.5,
    cy: 213.5,
    r: 5.5,
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M774.5 203L779.5 211.5L786.5 203",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 761,
    y: 134.864
  }, "(R)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 761,
    y: 198.864
  }, "(R)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 761,
    y: 281.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 750,
    y: 344.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWCR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 580,
    y: 344.864
  }, "NWCR"))), /*#__PURE__*/React.createElement("text", {
    id: "RWCR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 585,
    y: 134.864
  }, "RWCR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWCR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 580,
    y: 425.864
  }, "NWCR"))), /*#__PURE__*/React.createElement("text", {
    id: "RWCR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 577,
    y: 488.864
  }, "RWCR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 759,
    y: 425.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(N)WR_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 758,
    y: 488.864
  }, "(N)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 758,
    y: 550.864
  }, "(R)WR"))), /*#__PURE__*/React.createElement("text", {
    id: "(R)WR_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 758,
    y: 614.864
  }, "(R)WR"))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M775 359.5L801 341.5V297.5H709V341.5L735 359.5",
    stroke: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 736,
    cy: 296.5,
    r: 5.5,
    transform: "rotate(-180 736 296.5)",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M770 286L775 294.5L782 286",
    stroke: "black",
    strokeWidth: 3
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 736,
    cy: 359.5,
    r: 5.5,
    transform: "rotate(-180 736 359.5)",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M770 349L775 357.5L782 349",
    stroke: "black",
    strokeWidth: 3
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 560.5,
    cy: 360.5,
    r: 5.5,
    transform: "rotate(-180 560.5 360.5)",
    fill: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 190.5,
    cy: 359.5,
    r: 5.5,
    transform: "rotate(-180 190.5 359.5)",
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53",
    cx: 190.5,
    cy: 442.5,
    r: 5.5,
    transform: "rotate(-180 190.5 442.5)",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M594.5 350L599.5 358.5L606.5 350",
    stroke: "black",
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M739.5 442.5L713.5 460.5V504.5H805.5V460.5L779.5 442.5",
    stroke: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 740.5,
    cy: 441.5,
    r: 5.5,
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M775.5 432L780.5 440.5L787.5 432",
    stroke: "black",
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M554.5 443.5L528.5 461.5V505.5H620.5V461.5L594.5 443.5",
    stroke: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 555.5,
    cy: 442.5,
    r: 5.5,
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M589.5 432L594.5 440.5L601.5 432",
    stroke: "black",
    strokeWidth: 3
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 555.5,
    cy: 504.5,
    r: 5.5,
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M589.5 494L594.5 502.5L601.5 494",
    stroke: "black",
    strokeWidth: 3
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 218.5,
    cy: 858.5,
    r: 5.5,
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M252.5 848L257.5 856.5L264.5 848",
    stroke: "black",
    strokeWidth: 3
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 43",
    cx: 587.5,
    cy: 792.5,
    r: 5.5,
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M542.5 780L547.5 788.5L554.5 780",
    stroke: "black",
    strokeWidth: 3
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 587.5,
    cy: 888.5,
    r: 5.5,
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M542.5 877L547.5 885.5L554.5 877",
    stroke: "black",
    strokeWidth: 3
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 587.5,
    cy: 959.5,
    r: 5.5,
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M542.5 948L547.5 956.5L554.5 948",
    stroke: "black",
    strokeWidth: 3
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 587.5,
    cy: 1053.5,
    r: 5.5,
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M542.5 1042L547.5 1050.5L554.5 1042",
    stroke: "black",
    strokeWidth: 3
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    cx: 443.5,
    cy: 888.5,
    r: 5.5,
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 31",
    d: "M411.5 899.5L406.5 891L399.5 899.5",
    stroke: "black",
    strokeWidth: 3
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 445.5,
    cy: 792.5,
    r: 5.5,
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 32",
    d: "M413.5 802.5L408.5 794L401.5 802.5",
    stroke: "black",
    strokeWidth: 3
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 440.5,
    cy: 960.5,
    r: 5.5,
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M408.5 970.5L403.5 962L396.5 970.5",
    stroke: "black",
    strokeWidth: 3
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 440.5,
    cy: 1054.5,
    r: 5.5,
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M408.5 1064.5L403.5 1056L396.5 1064.5",
    stroke: "black",
    strokeWidth: 3
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 217.5,
    cy: 1027.5,
    r: 5.5,
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M251.5 1017L256.5 1025.5L263.5 1017",
    stroke: "black",
    strokeWidth: 3
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M739.5 505.5L713.5 523.5V567.5H805.5V523.5L779.5 504.5",
    stroke: "black"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 740.5,
    cy: 504.5,
    r: 5.5,
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M774.5 494L779.5 502.5L786.5 494",
    stroke: "black",
    strokeWidth: 3
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M739.5 568.5L713.5 586.5V630.5H805.5V586.5L779.5 567.5",
    stroke: "black"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 740.5,
    cy: 567.5,
    r: 5.5,
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M774.5 557L779.5 565.5L786.5 557",
    stroke: "black",
    strokeWidth: 3
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 740.5,
    cy: 629.5,
    r: 5.5,
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M774.5 619L779.5 627.5L786.5 619",
    stroke: "black",
    strokeWidth: 3
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Indoor_Detection_RNWKR_Wire1",
    d: "M155 791.5H1085",
    stroke: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Indoor_Detection_RNWKR_Wire2",
    d: "M155 888.5H1019.5H1172",
    stroke: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Indoor_Detection_RRWKR_Wire1",
    d: "M155 959.5H955.001",
    stroke: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Indoor_Detection_RRWKR_Wire2",
    d: "M155 1053.5H1017",
    stroke: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Indoor_Detection_RRWKR_Wire3",
    d: "M1089 1052H1127",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Detection"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 28",
    d: "M1097.5 791C1097.5 796.778 1092.6 801.5 1086.5 801.5C1080.4 801.5 1075.5 796.778 1075.5 791C1075.5 785.222 1080.4 780.5 1086.5 780.5C1092.6 780.5 1097.5 785.222 1097.5 791Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 29",
    d: "M1139.5 791C1139.5 796.778 1134.6 801.5 1128.5 801.5C1122.4 801.5 1117.5 796.778 1117.5 791C1117.5 785.222 1122.4 780.5 1128.5 780.5C1134.6 780.5 1139.5 785.222 1139.5 791Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 45",
    x1: 1086,
    y1: 780.457,
    x2: 1130,
    y2: 780.457,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 46",
    x1: 1086,
    y1: 801.5,
    x2: 1130,
    y2: 801.5,
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Detection_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 28_2",
    d: "M1269.15 791C1269.15 796.785 1264.31 801.5 1258.32 801.5C1252.33 801.5 1247.5 796.785 1247.5 791C1247.5 785.215 1252.33 780.5 1258.32 780.5C1264.31 780.5 1269.15 785.215 1269.15 791Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 29_2",
    d: "M1310.5 791C1310.5 796.785 1305.67 801.5 1299.68 801.5C1293.69 801.5 1288.85 796.785 1288.85 791C1288.85 785.215 1293.69 780.5 1299.68 780.5C1305.67 780.5 1310.5 785.215 1310.5 791Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 45_2",
    x1: 1257.83,
    y1: 780.457,
    x2: 1301.15,
    y2: 780.457,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 46_2",
    x1: 1257.83,
    y1: 801.5,
    x2: 1301.15,
    y2: 801.5,
    stroke: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Detection_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 28_3",
    d: "M1280.15 889C1280.15 894.785 1275.31 899.5 1269.32 899.5C1263.33 899.5 1258.5 894.785 1258.5 889C1258.5 883.215 1263.33 878.5 1269.32 878.5C1275.31 878.5 1280.15 883.215 1280.15 889Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 29_3",
    d: "M1321.5 889C1321.5 894.785 1316.67 899.5 1310.68 899.5C1304.69 899.5 1299.85 894.785 1299.85 889C1299.85 883.215 1304.69 878.5 1310.68 878.5C1316.67 878.5 1321.5 883.215 1321.5 889Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 45_3",
    x1: 1268.83,
    y1: 878.457,
    x2: 1312.15,
    y2: 878.457,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 46_3",
    x1: 1268.83,
    y1: 899.5,
    x2: 1312.15,
    y2: 899.5,
    stroke: "black"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Line 50",
    d: "M209 360.816C228 401.5 251.5 319.5 271.008 360.816",
    stroke: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Line 59",
    d: "M1453 792.16C1467.09 833.408 1484.53 750.272 1499 792.16",
    stroke: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Line 51",
    d: "M209 442.816C228 483.5 251.5 401.5 271.008 442.816",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 37",
    cx: 1173,
    cy: 888.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 50",
    cx: 1017,
    cy: 1052.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 51",
    cx: 1082,
    cy: 1052.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 38",
    cx: 1241,
    cy: 888,
    r: 7,
    fill: "black"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 1499.5,
    cy: 791.5,
    r: 4.5,
    fill: "black"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 1499.5,
    cy: 889.5,
    r: 4.5,
    fill: "black"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 1454.5,
    cy: 791.5,
    r: 4.5,
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 30",
    d: "M1194.5 849L1204.49 855.338L1215.5 848L1215 862L1204.49 855.338L1194.5 862V849Z",
    fill: "black",
    stroke: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Line 52",
    d: "M1180 888.5H1195",
    stroke: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Line 62",
    d: "M1060 1053H1075",
    stroke: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Line 63",
    d: "M1024 1053H1039",
    stroke: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Line 55",
    d: "M1216 888.5H1236",
    stroke: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Line 67",
    d: "M1245 888.5H1265",
    stroke: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Line 53",
    d: "M1194.5 849V889",
    stroke: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Line 54",
    d: "M1215.5 848V889",
    stroke: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M1039 1013L1048.99 1019.34L1060 1012L1059.5 1026L1048.99 1019.34L1039 1026V1013Z",
    fill: "black",
    stroke: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Line 60",
    d: "M1039 1013V1053",
    stroke: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Line 61",
    d: "M1060 1012V1053.5",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "PointA_Operation",
    x: 1011.5,
    y: 119.5,
    width: 225,
    height: 293,
    rx: 13.5,
    stroke: "#D6D3D3",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "PointB_Operation",
    x: 1301.5,
    y: 119.5,
    width: 225,
    height: 293,
    rx: 13.5,
    stroke: "#D6D3D3",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "Point2_Operation_Name_Box_Text",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1114,
    y: 442.864
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "Point2_Operation_Name_Box_Text_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1408,
    y: 444.864
  }, ".........."))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 40",
    d: "M674 761.5V773.5H964V761.5",
    stroke: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M671 71V83H961V71",
    stroke: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 1567.5,
    y: 80.5,
    width: 236,
    height: 427,
    rx: 14.5,
    fill: "#FFF7E9",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "VNO=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 144.455
  }, "VNO="))), /*#__PURE__*/React.createElement("text", {
    id: "VRO=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 173.455
  }, "VRO="))), /*#__PURE__*/React.createElement("text", {
    id: "OC=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 232.455
  }, "OC="))), /*#__PURE__*/React.createElement("text", {
    id: "DIR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 256.455
  }, "DIR="))), /*#__PURE__*/React.createElement("text", {
    id: "PC=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 202.455
  }, "PC="))), /*#__PURE__*/React.createElement("text", {
    id: "VNO=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 375.455
  }, "VNO="))), /*#__PURE__*/React.createElement("text", {
    id: "VRO=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 404.455
  }, "VRO="))), /*#__PURE__*/React.createElement("text", {
    id: "OC=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 463.455
  }, "OC="))), /*#__PURE__*/React.createElement("text", {
    id: "PC=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 433.455
  }, "PC="))), /*#__PURE__*/React.createElement("text", {
    id: "Point2_Operation_Name",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627,
    y: 118.864
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "Point1_Operation_Name",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627,
    y: 337.864
  }, ".........."))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 1579.5,
    y: 103.5,
    width: 134,
    height: 23,
    rx: 7.5,
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: 1579.5,
    y: 321.5,
    width: 134,
    height: 23,
    rx: 7.5,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line 68",
    x1: 1108.5,
    y1: 772,
    x2: 1108.5,
    y2: 810,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ND_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1282,
    y: 778.455
  }, "ND"))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line 69",
    x1: 1279.5,
    y1: 772,
    x2: 1279.5,
    y2: 810,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RD_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1292,
    y: 876.455
  }, "RD"))), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "Line 70",
    x1: 1289.5,
    y1: 870,
    x2: 1289.5,
    y2: 908,
    stroke: "black"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 54",
    cx: 1192,
    cy: 1052.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 55",
    cx: 1133,
    cy: 1052.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 71",
    x1: 1130,
    y1: 1052.5,
    x2: 1192,
    y2: 1052.5,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 72",
    x1: 1159.5,
    y1: 1032,
    x2: 1159.5,
    y2: 1070,
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RD_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 991,
    y: 950.455
  }, "RD"))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 56",
    cx: 1019,
    cy: 959.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 57",
    cx: 960,
    cy: 959.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "Line 73",
    x1: 986.5,
    y1: 939,
    x2: 986.5,
    y2: 977,
    stroke: "black"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line 74",
    x1: 957,
    y1: 959.5,
    x2: 1019,
    y2: 959.5,
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "RD_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 1255,
    y: 953.455
  }, "RD"))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 58",
    cx: 1283,
    cy: 962.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 59",
    cx: 1224,
    cy: 962.5,
    rx: 7,
    ry: 7.5,
    fill: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line 75",
    x1: 1250.5,
    y1: 942,
    x2: 1250.5,
    y2: 980,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line 76",
    x1: 1221,
    y1: 962.5,
    x2: 1283,
    y2: 962.5,
    stroke: "black",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 1567.5,
    y: 551.5,
    width: 236,
    height: 236,
    rx: 14.5,
    fill: "#FFF7E9",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NWKR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 634.455
  }, "NWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 663.455
  }, "RWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "PointA_Detection_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 1617,
    y: 599.864
  }, ".........."))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 1581.5,
    y: 584.5,
    width: 105,
    height: 22,
    rx: 7.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NWKR=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 747.455
  }, "NWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 776.455
  }, "RWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "PointB_Detection_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 1617,
    y: 712.864
  }, ".........."))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 1581.5,
    y: 697.5,
    width: 105,
    height: 22,
    rx: 7.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Indoor Detection",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 1611,
    y: 810.455
  }, "Indoor Detection"))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 1567.5,
    y: 819.5,
    width: 236,
    height: 236,
    rx: 14.5,
    fill: "#FFF7E9",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RNWKR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 900.455
  }, "RNWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "RRWKR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 929.455
  }, "RRWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "PointA_Detection_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 1617,
    y: 865.864
  }, ".........."))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 1581.5,
    y: 850.5,
    width: 105,
    height: 22,
    rx: 7.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Point_To_Set"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PM_A_VNO_Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 144.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_VRO_Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 173.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_PC_Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 202.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_OC_Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 232.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_DIR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 256.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_VNO_Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 375.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_VRO_Voltage",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 404.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_PC_Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 433.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_OC_Current",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 463.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION_BOX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 1621,
    y: 76.4545
  }, "........................"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_NWKR_Voltage_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 634.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_RWKR_Voltage_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 663.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_NWKR_Voltage_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 747.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_RWKR_Voltage_Outdoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 776.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_RNWKR_Voltage_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 900.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_RRWKR_Voltage_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 929.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_RNWKR_Voltage_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 1012.45
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_RRWKR_Voltage_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 1654,
    y: 1041.45
  }, "............")))), /*#__PURE__*/React.createElement("text", {
    id: "RNWKR=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 1012.45
  }, "RNWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "RRWKR=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 1586,
    y: 1041.45
  }, "RRWKR="))), /*#__PURE__*/React.createElement("text", {
    id: "PointB_Detection_Indoor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 1617,
    y: 977.864
  }, ".........."))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 1581.5,
    y: 962.5,
    width: 105,
    height: 22,
    rx: 7.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DIR=_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584,
    y: 488.455
  }, "DIR="))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_DIR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 1652,
    y: 488.455
  }, "............"))), /*#__PURE__*/React.createElement("text", {
    id: "PointA_Operation_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 1621,
    y: 98.4545
  }, "........................"))), /*#__PURE__*/React.createElement("text", {
    id: "PointB_Operation_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 1618,
    y: 314.455
  }, "........................"))), /*#__PURE__*/React.createElement("text", {
    id: "PointA_Outdoor_Detection_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 1619,
    y: 577.455
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "PointB_Outdoor_Detection_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 1619,
    y: 691.455
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "PointA_Indoor_Detection_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 1619,
    y: 843.455
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "PointB_Indoor_Detection_Date_Time",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 1620,
    y: 957.455
  }, "..........")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1905,
    height: 1135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmCircuitDiagram);
export default __webpack_public_path__ + "static/media/pm_circuit_diagram.4809dae4a9f99b529e11b527a25b29f9.svg";
export { ForwardRef as ReactComponent };